import mutations from './mutations/index'
import actions from './actions/index'
import getters from './getters/index'


const state = {

  // 颜色相关配置
  colors: {
    // 涨跌颜色
    up: '#f00',
    upBorder: '#f00',
    down: '#090',
    downBorder: '#090',

    // 均线颜色
    ma5: "#f0f",
    ma10: "#00ffff",
    ma20: "#FF0",
    ma55: "#c00",
    ma89: "#009000",
    ma144: "#000090",

    // KDJ颜色
    k: "#ff00ff",
    d: "#00ffff",
    j: "#ffff00",

    // dif、dea
    dif: "#00ffff",
    dea: "#ffff00",

    // 背景色
    chartColor: '#eee',  // 图表文字色
    chartBg: '#000',  // 图表背景色

    gridBorder: '#875f22',   // 边框线
    gridSplitLine: '#875f22',   // 分隔线
    gridAxis: '#e5be51'  // 坐标刻度
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
}
